import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { EdiSourceNode, EdiViewBlock, EdiViewField } from '../../../models/edi-viewer';

@Component({
  selector: 'lib-edi-view-block',
  templateUrl: './edi-view-block.component.html',
  styleUrls: ['./edi-view-block.component.scss'],
  standalone: false
})
export class EdiViewBlockComponent {
  @Input() block: EdiViewBlock;
  @Input() nodeIndex: Record<string, EdiSourceNode> = {};
  @Output() sourceSelected = new EventEmitter<string[]>();

  @HostBinding('class')
  get hostClass(): string {
    return `edi-view-block-host edi-view-block-${(this.block?.type || 'unknown').toLowerCase().replace(/_/g, '-')}`;
  }

  get tableColumns(): string[] {
    const labels = new Set<string>();
    for (const row of this.block?.children || []) {
      for (const field of row.fields || []) labels.add(field.label);
    }
    return Array.from(labels);
  }

  value(field: EdiViewField): string {
    const separator = ['long-text', 'address-line'].includes(field.displayHint || '') ? '\n' : ', ';
    return (field.sourceNodeIds || [])
      .map(id => this.nodeIndex[id])
      .filter(node => !!node)
      .map(node => node.value ?? node.raw ?? '—')
      .join(separator);
  }

  fieldClass(field: EdiViewField): string {
    const hint = (field.displayHint || '').toLowerCase();
    const semantic = (field.semantic || '').toLowerCase();
    if (hint === 'party-name' || semantic.endsWith('.name') || semantic.includes('party.name')) return 'party-name';
    if (['address-line', 'postal-code', 'city', 'country'].includes(hint) || semantic.includes('address'))
      return 'party-address';
    if (['phone', 'email'].includes(hint) || semantic.includes('contact')) return 'party-contact';
    return '';
  }

  fieldForColumn(row: EdiViewBlock, label: string): EdiViewField | undefined {
    return (row.fields || []).find(field => field.label === label);
  }

  select(field?: EdiViewField): void {
    if (field) this.sourceSelected.emit(field.sourceNodeIds);
  }
}
